const PUBLIC_FOCUSED_PATHS = new Set([
  '/public-login',
  '/register',
  '/resident-concern',
  '/apply',
  '/apply/permit',
]);

const normalizedPath = (pathname = '') => pathname.length > 1
  ? pathname.replace(/\/+$/, '')
  : pathname;

export const isPublicFocusedWorkflow = (pathname) => {
  const path = normalizedPath(pathname);
  return PUBLIC_FOCUSED_PATHS.has(path) || /^\/pay\/[^/]+$/.test(path);
};

export const isStaffFocusedWorkflow = (pathname) => {
  const path = normalizedPath(pathname);
  return path === '/observations/new'
    || /^\/inspections\/[^/]+\/checklist(?:\/review)?$/.test(path)
    || /^\/inspections\/[^/]+\/review$/.test(path)
    || /^\/vehicles\/[^/]+\/inspect$/.test(path);
};
